import { Typography } from "antd";
import { isEmpty } from "lodash";
import React, { useMemo } from "react";
import { AssetEsDto } from "types/assetdetails";
import { formatArrayField } from "utils/assetUtils";
import { CellRenderers } from "utils/tableUtils";
import { CopyContent } from "views/Findings/FindingDetails/FindingDetailsSourceInfo";

export const useAssetImageFields = (assetDetails: AssetEsDto) => {
  const imageFields = useMemo(() => {
    const fields = [
      {
        label: "Registry",
        name: "registry",
        formatter: () => formatArrayField(assetDetails.registry),
      },
      {
        label: "Cloud Provider",
        name: "cloudProvider",
        formatter: () => formatArrayField(assetDetails.cloudProvider),
      },
      {
        label: "OS",
        name: "os",
        formatter: () => formatArrayField(assetDetails.os),
      },
      {
        label: "OS Version",
        name: "osVersion",
        containerClassName: "flex-column",
        formatter: () => formatArrayField(assetDetails.osVersion),
      },
      {
        label: "Cluster",
        name: "cluster",
        formatter: () => formatArrayField(assetDetails.cluster),
      },
      {
        label: "Namespace",
        name: "namespace",
        formatter: () => formatArrayField(assetDetails.namespace),
      },
      {
        label: "Account ID",
        name: "cloudAccountId",
        formatter: () => formatArrayField(assetDetails.cloudAccountId),
      },
      {
        label: "ARN",
        name: "arn",
        containerClassName: "flex-column",
        formatter: () => formatArrayField(assetDetails.arn),
        extra: !isEmpty(assetDetails.arn) ? (
          <CopyContent content={assetDetails.arn.join(", ")} fieldLabel="ARN" />
        ) : null,
      },
      {
        label: "Code Repository",
        name: "codeRepo",
        containerClassName: "flex-column",
        formatter: () =>
          !isEmpty(assetDetails.codeRepo) &&
          assetDetails.codeRepo.repositoryName ? (
            <Typography.Link
              href={assetDetails.codeRepo.repositoryUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {assetDetails.codeRepo.repositoryName}
            </Typography.Link>
          ) : (
            CellRenderers.VALUE_OR_NA()
          ),
      },
    ];
    return fields.map((hostField) => ({ ...hostField, disabledPin: true }));
  }, [assetDetails]);
  return imageFields;
};
